import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.10992 14.38C7.92992 14 7.97992 13.55 8.24992 13.23L11.3799 9.4C11.5899 9.15 11.8999 9 12.2299 9C12.5599 9 12.8699 9.14 13.0799 9.4L16.2499 13.2C16.5199 13.52 16.5799 13.97 16.3999 14.35C16.2199 14.73 15.8299 14.97 15.4099 14.97L9.10992 15C8.68992 15 8.29992 14.76 8.11992 14.38H8.10992Z" fill={ fill || 'currentColor' }/>
    </svg>
);
